import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FieldSelect from '@react-form-fields/material-ui/components/Select';
import { dateFormat, dateParse } from 'formatters/date';
import { getStatusLabel, statusesColors } from 'interfaces/dashboard';
import { statuses } from 'interfaces/file';
import React, { memo } from 'react';
import { useState } from 'react';
import { Legend, Line, LineChart, LineProps, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import Card from '../Component/Card';

interface IProps {
  metrics: any[];
}

const useStyles = makeStyles(theme => ({
  table: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2)
  },
  content: {
    alignSelf: 'center'
  },
  middleText: theme.typography.h5,
  iconStatus: {
    verticalAlign: 'middle'
  },
  label: {
    ...theme.typography.h6,
    fill: '#000000',
    opacity: 0.6,
  },
  select: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.primary.light,
    fontSize: 16,
    padding: '6px 26px 6px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  typography: {
    fontWeight: 'bold',
  }
}));

const HistoricStatus = memo<IProps>((props: IProps) => {
  const { metrics } = props;
  const classes = useStyles();
  const [statusFilter, setStatusFilter] = useState<statuses[]>([statuses.APPROV, statuses.EXPIRED, statuses.DISAPPROV]);
  const statusOptions = Object.keys(statuses).map(s => ({ value: s, label: getStatusLabel(s) }));

  const getLineProps = (status: statuses): LineProps => ({
    type: 'monotone',
    dataKey: status,
    stroke: statusesColors[status],
    strokeWidth: 3,
    fill: statusesColors[status],
    activeDot: {
      stroke: statusesColors[status],
      fill: 'white'
    }
  });

  const handleChangeStatus = (value: statuses[]) => {
    setStatusFilter(value);
  };

  const formatterTicker = (date: string) => dateFormat(dateParse(date, 'yyyy-MM'), 'MMM/yy');

  return (
    <Card>
      <Grid container justify="space-between" spacing={1}>
        <Grid item>
          <Typography className={classes.typography} color='primary' variant='subtitle1'>Histórico</Typography>
        </Grid>
        <Grid item xs={4}>
          <FieldSelect
            value={statusFilter}
            options={statusOptions}
            onChange={handleChangeStatus}
            classes={{ select: classes.select }}
            fullWidth
            margin='none'
            multiple
          />
        </Grid>
        <Grid item xs={12}>
          <div className={classes.table}>
            <ResponsiveContainer width="100%" height={180}>
              <LineChart
                height={150}
                data={metrics}
              >
                <YAxis axisLine={false} tickLine={false} width={35} />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tickFormatter={formatterTicker} />
                <Tooltip
                  labelFormatter={formatterTicker}
                  formatter={(value, name) => [value, getStatusLabel(name, true)]}
                />
                <Legend formatter={(value) => getStatusLabel(value, true)} />
                {statusFilter.map(i => (
                  <Line key={`line-${i}`} {...getLineProps(i)} />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Grid>
      </Grid>
    </Card>
  );
});

export default HistoricStatus;